import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function AccesoALasPlataformas() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>VI. ACCESO A LAS PLATAFORMAS</h4>
          <h5 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                  }}>ACCESO Y FUNCIONAMIENTO DE LA APP</h5>
          <br></br>
          <ol style={{ listStyleType: 'lower-alpha', paddingLeft: '20px' }}>
            <li>
              <p>
                <strong>Descarga de la App:</strong> El Usuario y/o Cliente Corporativo debe ingresar a la tienda de aplicaciones correspondiente a su dispositivo móvil, ya sea Android o iOS, y descargar la App **"Go Parking"**.
              </p>
            </li>
            <li>
              <p>
                <strong>Registro Inicial:</strong> Una vez descargada la App, el Usuario y/o Cliente Corporativo deberá ingresar su número de celular para iniciar el proceso de pre-registro. Para continuar con el proceso de registro, el Usuario deberá selección el tipo de documento, número de documento y ciudad de residencia.
              </p>
            </li>
            <li>
              <p>
                <strong>Verificación de Usuario:</strong> Después de ingresar todos los datos, se realizará una verificación del Usuario con un código que será enviado por mensaje de texto al número de teléfono proporcionado.
              </p>
            </li>
            <li>
              <p>
                <strong>Aceptación de Términos y Condiciones:</strong> Tras ingresar sus datos, el Usuario y/o Cliente Corporativo debe leer y aceptar los presentes T&C.
              </p>
            </li>
            <li>
              <p>
                <strong>Aceptación de la Política de Tratamiento de Datos Personales:</strong> Así mismo, el Usuario y/o Cliente Corporativo debe leer y aceptar la Política de Tratamiento de Datos de Parking mediante la cual adquiere conocimiento sobre el uso de sus datos, los derechos que le asisten y los canales de atención disponibles para su ejercicio.
              </p>
            </li>
            <li>
              <p>
                <strong>Acceso y Funcionamiento de la App:</strong> Una vez el Usuario y/o Cliente Corporativo descargue la App y complete el registro quedará de forma inmediata vinculado al plan de fidelización **"Be Parking"**, en caso de ya estar vinculado a este plan de fidelización, se actualizarán sus datos personales conforme con la Política de Tratamiento de Datos Personales de Parking.
              </p>
            </li>
            <li>
              <p>
                <strong>Inicio de sesión:</strong> Para cada inicio de sesión, se enviará un código de verificación mediante mensaje de texto al número de celular suministrado por el Usuario y/o Cliente Corporativo.
              </p>
            </li>
            <li>
              <p>
                <strong>Finalización del Registro:</strong> Una vez verificado el Usuario, quedará registrado y asociado a facturación electrónica.
              </p>
            </li>
            <li>
              <p>
                <strong>Permisos de Ubicación y Notificaciones:</strong> Para utilizar el mapa y recibir notificaciones importantes, el Usuario deberá otorgar permisos de ubicación y habilitar las notificaciones en su dispositivo.
              </p>
            </li>
            <li>
              <p>
                <strong>Acceso y Uso de la App:</strong> Una vez completados todos los pasos anteriores y otorgados los permisos necesarios, el Usuario podrá empezar a utilizar la App para gestionar su estacionamiento.
              </p>
            </li>
            <li>
              <p>
                El Usuario solo puede tener una cuenta de usuario.
              </p>
            </li>
            <li>
              <p>
                El Usuario es responsable de toda la actividad que ocurre en su cuenta y se compromete a mantener la información en su cuenta de forma exacta, completa, actualizada, y segura. No hacerlo, podrá resultar en su imposibilidad para acceder y utilizar los Servicios y en la resolución por parte de Parking de estos T&C.
              </p>
            </li>
            <li>
              <p>
                El Usuario acepta que Parking podrá ofrecer servicios de publicidad a través de su App.
              </p>
            </li>   
          </ol>
        </Col>
      </Row>
    </Container>
  );
}